export class PagedList<T> {
  TotalCount: number;
  Items: T[];
}
